module.exports = __webpack_public_path__ + "img/KM.49234f04.png";